<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Référence cadastrale : </span>
    <span>
      {{ cityCode || "-" }} {{ cadastre.plotPrefixe || "-" }}
      {{ cadastre.plotSection || "-" }} {{ cadastre.plotNumber || "-" }}
    </span>
  </div>

  <div class="col-6">
    <span class="fw-bold">Commune : </span>
    <span>{{ cityLabel || "-" }}</span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Surface parcelle : </span>
    <span>
      {{ cadastre.plotTotalArea || "-" }}
      {{ cadastre.plotTotalArea ? "m²" : "" }}
    </span>
  </div>

  <div class="col-6">
    <span class="fw-bold">Emprise au sol : </span>
    <span>
      {{ cadastre.plotBuildingArea || "-" }}
      {{ cadastre.plotBuildingArea ? "m²" : "" }}
    </span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Surface libre : </span>
    <span>
      {{ cadastre.plotFreeArea || "-" }}
      {{ cadastre.plotFreeArea ? "m²" : "" }}
    </span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Bâtiments : </span>
    <span>{{ cadastre.buildings.length || "-" }}</span>
  </div>
</div>

<div class="row mb-4">
  <div class="col-6">
    <span class="fw-bold">Commentaire : </span>
    <span>{{ cadastre.comment || "-" }}</span>
  </div>
</div>

<div *ngIf="cartographieBinary" class="d-flex justify-content-center">
  <img
    [src]="cartographieBinary"
    alt="Cartographie du bien"
    class="img-fluid rounded mt-4 border border-1"
  />
</div>
